import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { NumberToWordsTool } from "../components/NumberToWordsTool";
import { NwBreadcrumb } from "../components/NwBreadcrumb";
import { NwExplainer } from "../components/NwExplainer";

export function NumberToWordsPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <NwBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.nw_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.nw_intro()}
          </p>
        </header>

        <NumberToWordsTool />

        <NwExplainer
          howTo={m.nw_howto()}
          faqs={[
            { q: m.nw_faq1_q(), a: m.nw_faq1_a() },
            { q: m.nw_faq2_q(), a: m.nw_faq2_a() },
            { q: m.nw_faq3_q(), a: m.nw_faq3_a() },
            { q: m.nw_faq4_q(), a: m.nw_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
